import { CommonModule } from '@angular/common';
import { Component, inject, TemplateRef } from '@angular/core';
import { DataTablesModule } from 'angular-datatables';
import { CommonService } from '../../Model/Common/common.service';
import { NgbDatepickerModule, NgbDropdownModule, NgbModal, NgbOffcanvas, NgbOffcanvasRef } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { MusterAttendanceService } from '../../Model/MusterAttendance/muster-attendance.service';
import { FormsModule } from '@angular/forms';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { MusterAttendanceSummaryComponent } from '../muster-attendance-summary/muster-attendance-summary.component';
import { MusterAttendanceEmpWiseSummaryComponent } from '../muster-attendance-emp-wise-summary/muster-attendance-emp-wise-summary.component';
import { MusterAttendanceDateWiseSummaryComponent } from '../muster-attendance-date-wise-summary/muster-attendance-date-wise-summary.component';
import { MusterAttendanceSendPOCComponent } from '../muster-attendance-send-poc/muster-attendance-send-poc.component';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import { UtilityService } from '../../Model/utility/utility.service';
import { Subject } from 'rxjs';
import { DesignationSummaryFormComponent } from '../designation-summary-form/designation-summary-form.component';
import { ComboService } from '../../Model/Combo/combo.service';
import { SessionService } from '../../Util/Session/session.service';
import { MusterAttendancePOCTrackingHistoryComponent } from '../muster-attendance-poctracking-history/muster-attendance-poctracking-history.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { debug } from 'node:util';

@Component({
  selector: 'app-muster-attendance',
  standalone: true,
  imports: [CommonModule, DataTablesModule, FormsModule, MusterAttendanceSummaryComponent, NgbDatepickerModule, NgbDropdownModule, NgSelectModule, LoaderComponent, NgbDropdownModule, NgbTooltip],
  templateUrl: './muster-attendance.component.html',
  styleUrl: './muster-attendance.component.scss'
})
export class MusterAttendanceComponent {
  isDisabled: boolean = false;
  isValidate: boolean = true;
  Dropdowns = [];
  Zones = [] as any;
  Clients = [] as any;
  Branchs = [] as any;
  Sectors = [] as any;
  Groups = [] as any;
  Sites = [] as any;
  updatedDatas = [] as any;
  user = [] as any;
  SummaryData = [] as any;
  dateKeys = [] as any;
  DesignationSummaryData = [] as any;
  DesignationSummaryBillingData = [] as any;
  LeaveBalance = [] as any;
  Tracking = [] as any;
  Type = '';
  SiteStatus = 'Active';
  ExcelData = {
    Sheet1: [],
    Sheet2: [],
    Sheet3: [],
    ExcelFormate: []
  };
  PocDatas = [] as any;

  POCInfo = {
    IsInternalPOCApplicable: false,
    InternalPOCStatus: null as any,
    IsClientPOCApplicable: false,
    ClientPOCStatus: null as any,
    IsLocked: false,
    IsReset: false,
    IsExcel: false,
    SalaryStartDate: null,
    SalaryEndDate: null,
    MonthlyAttachmentURL: null,
    BillingAttachmentURL: null,
    IsAttendanceLocked: false,
    IPOCAttachment: null,
    IPOCAttachmentURL: null,
  }


  ErrorHighlight = [] as any;
  IsAllow = true;

  CompanyPermiter = {
    IsAttendanceBeforeDaysAllowed: false,
    AttendanceBeforeDays: 0,
    IsAttendanceAfterDaysAllowed: false,
    AttendanceAfterDays: 0,
    IsUpdateDesignationDutyAllowed: false,
    IsAttendanceResetAllowed: false,
    IsAttendanceDeleteAllowed: false,
    IsAttendanceForSameDayAllowed: false,
    IsCheckingLeaveBalanceInMusterApplicable: false,
    TodayDate: null as any,
    IsRelievingOTDisable: false
  }

  filter = {
    MonthYear: null as any,
    ZoneMasterID: null as any,
    SectorId: null as any,
    GroupId: null as any,
    BranchMasterID: null as any,
    Branch: null as any,
    ClientGroupMasterID: null as any,
    Client: null as any,
    SiteMasterID: null as any,
    ESS_SaveAttendance_OAS: [] as any,
    ListType: 1,
  }

  POCFilter = {
    SelectType: '',
    SiteId: null as any,
    SiteCode: null as any,
    SiteName: null as any,
    MonthName: null as any,
    YearName: null as any,
    MailIds: null as any,
    MailId: null as any,
    IsMonthlySummary: true,
    IsBillingSummary: true,
    ApprovalStatus: null,
    CompanyCode: null,
    CompanyName: null,
    DomainName: null,
    IPOCAttachment: null,
  }

  AttendanceTypes = [] as any;

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild('musterSummary') musterSummaryComponent!: MusterAttendanceSummaryComponent;

  private SPocService = inject(NgbOffcanvas);
  SPocServiceRef?: NgbOffcanvasRef;

  dtOptions: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: false,
    paging: false,
    scrollX: true,
    scrollY: '350px',
    scrollCollapse: true,
    pageLength: 10,
    lengthMenu: [10, 25, 50, 100],
    info: false,
    language: {
      searchPlaceholder: 'Search...',
    },
    stateSave: true,
    processing: false,
    order: [[0, 'asc']],
    columnDefs: [
      {
        targets: 0,
        width: '5px',
      },
      {
        targets: 3,
        width: '60px',
      },
      {
        targets: 4,
        width: '60px',
      },
      {
        targets: 5,
        width: '60px',
      },
      {
        targets: 6,
        width: '60px',
      },
      {
        targets: 7,
        width: '60px',
      },
      {
        targets: 8,
        width: '60px',
      },
      {
        targets: 9,
        width: '60px',
      },
      {
        targets: 10,
        width: '60px',
      },
      {
        targets: 11,
        width: '60px',
      },
    ],
    columns: [],
  };

  dtOptionsPOC: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: false,
    paging: false,
    scrollY: '350px',
    scrollCollapse: true,
    pageLength: 10,
    info: false,
    lengthMenu: [10, 25, 50, 100],
    language: {
      searchPlaceholder: 'Search...',
    },
    stateSave: true,
    processing: false,
    order: [[0, 'asc']],
    createdRow: (row: Node, data: any, index: number) => {
      const $checkbox = $(row).find('.row-checkbox');

      $checkbox.prop('checked', data.selected ?? false);

      $checkbox.off('change').on('change', (event: any) => {
        const isChecked = event.target.checked;
        data.selected = isChecked;
        this.PocDatas[index].selected = isChecked;
      });
    },
    columnDefs: [
      {
        targets: 0,
        width: '10px',
      },
      {
        targets: 1,
        width: '10px',
      }
    ],
    columns: [
      {
        title: '#',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          return `<strong>${meta.row + (meta.settings.displayStart ?? 0) + 1}</strong>`;
        },

        orderable: true,
      },
      {
        title: `Check`,
        data: null,
        orderable: false,
        render: (data: any, type: any, row: any, meta: any) => {
          return `<input type="checkbox" class="row-checkbox custom-checkbox" data-row-index="${meta.row}">`;
        },
      },
      {
        title: 'Name',
        data: (row: any) => {
          return this.Type == 'I' ? row.InternalPOCName : row.ClientPOCName;
        },
        className: 'fw-bold',
        orderable: true,
      },
      {
        title: 'Email',
        data: (row: any) => {
          return this.Type == 'I' ? row.InternalPOCMailId : row.ClientPOCMailId;
        },
        className: 'fw-bold',
        orderable: true,
      },
      // {
      //   title: 'Mobile No',
      //   data: (row: any) => {
      //     return this.Type == 'I' ? row.InternalPOCMobileNo : row.ClientPOCMobileNo;
      //   },
      //   orderable: true,
      // },
    ],
  };

  dtOptionsTracking: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: false,
    paging: false,
    scrollY: '350px',
    scrollCollapse: true,
    pageLength: 10,
    ordering: false,
    lengthMenu: [10, 25, 50, 100],
    info: false,
    language: {
      searchPlaceholder: 'Search...',
    },
    stateSave: true,
    processing: false,
    order: [[0, 'asc']],
    columnDefs: [
      {
        targets: 0,
        width: '5px',
      },
      {
        targets: 1,
        width: '200px',
      },
      {
        targets: 2,
        width: '200px',
      },
    ],
    columns: [
      {
        title: '#',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          return `<strong>${meta.row + (meta.settings.displayStart ?? 0) + 1}</strong>`;
        },
        orderable: true,
      },
      {
        title: 'SPOC EMAIL SENT ON',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          let InbadgeClass = '';
          let ClbadgeClass = '';

          if (this.common.ToLowerCase(row.InternalPOCStatus) == 'approved')
            InbadgeClass = 'success';
          else if (this.common.ToLowerCase(row.InternalPOCStatus) === 'pending')
            InbadgeClass = 'warning';
          else if (this.common.ToLowerCase(row.InternalPOCStatus) === 'rejected')
            InbadgeClass = 'danger';

          if (this.common.ToLowerCase(row.ClientPOCStatus) == 'approved')
            ClbadgeClass = 'success';
          else if (this.common.ToLowerCase(row.ClientPOCStatus) === 'pending')
            ClbadgeClass = 'warning';
          else if (this.common.ToLowerCase(row.ClientPOCStatus) === 'rejected')
            ClbadgeClass = 'danger';

          return `
          <div><strong>Internal SPOC</strong><div class="ms-2"><span>${row.InternalPOCMailSentTo ?? ''}</span>
          <Br/><span>Sent on : ${row.InternalPOCMailSentOn ?? ''}</span>
          <span class="badge ${InbadgeClass}">${row.InternalPOCStatus ?? ''}</span>
          </div></div>
          
          <div class="mt-2"><strong>Client SPOC</strong><div class="ms-2"><span>${row.ClientPOCMailSentTo ?? ''}</span>
          <Br/><span>Sent on : ${row.ClientPOCMailSentOn ?? ''}</span>
          <span class="badge ${ClbadgeClass}">${row.ClientPOCStatus ?? ''}</span>
          </div></div>`;
        },
        orderable: true,
      },
      {
        title: 'SPOC EMAIL ACTION BY',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          return `
          <div><strong>Internal SPOC</strong><div class="ms-2"><span>Action By : ${row.InternalPOCActionBy ?? ''}</span>
          <Br/><span>Action on : ${row.InternalPOCActionOn ?? ''}</span>
          <Br/><span>Remark : ${row.InternalPOCRemark ?? ''}</span>
          </div></div>
          
          <div class="mt-2"><strong>Client SPOC</strong><div class="ms-2"><span>Action By : ${row.ClientPOCActionBy ?? ''}</span>
          <Br/><span>Action on : ${row.ClientPOCActionOn ?? ''}</span>
          <Br/><span>Remark : ${row.ClientPOCRemark ?? ''}</span>
          </div></div>`;
        },
        orderable: true,
      },
      {
        title: 'RESET ON',
        data: 'ResetDate',
        orderable: true,
      },
      {
        title: 'CREATED BY',
        data: 'CreatedBy',
        orderable: true,
      },
      {
        title: 'UPDATED BY',
        data: 'UpdatedBy',
        orderable: true,
      },
    ],
  };


  constructor(
    protected common: CommonService,
    private musterAttendance: MusterAttendanceService,
    protected dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal,
    private toast: ToastService,
    private utility: UtilityService,
    protected dateFormat: CustomDateParserFormatter,
    private combo: ComboService,
    private session: SessionService,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
  }

  ngOnInit() {
    this.ESS_FillComboOAS();

    // this.DesignationSummaryData = [
    //   { 'DesignationName': 'Electrcian', 'TotalStrength': 2, 'TotalShift': 3, 'WorkOnPublicHoliday': '-', 'ExtraShitsNotBilled': '-' },
    //   { 'DesignationName': 'Supervisor', 'TotalStrength': 2, 'TotalShift': 10, 'WorkOnPublicHoliday': '-', 'ExtraShitsNotBilled': '-' },
    //   { 'DesignationName': 'Junitor', 'TotalStrength': 28, 'TotalShift': 133, 'WorkOnPublicHoliday': '-', 'ExtraShitsNotBilled': '-' },
    //   { 'DesignationName': 'Mailroom Boy', 'TotalStrength': 2, 'TotalShift': 10, 'WorkOnPublicHoliday': '-', 'ExtraShitsNotBilled': '-' },
    //   { 'DesignationName': 'Facility Manager', 'TotalStrength': 1, 'TotalShift': 5, 'WorkOnPublicHoliday': '-', 'ExtraShitsNotBilled': '-' },
    //   { 'DesignationName': 'Pantry Boy', 'TotalStrength': '-', 'TotalShift': '-', 'WorkOnPublicHoliday': '-', 'ExtraShitsNotBilled': '-' }
    // ]

    // this.initializeDataTable('#designationWiseSummarydata', Object.values(this.DesignationSummaryData));
  }

  ngOnDestroy(): void {
    if ($.fn.dataTable.isDataTable('#designationWiseSummarydata')) {
      $('#designationWiseSummarydata').DataTable().destroy();
    }

    if ($.fn.dataTable.isDataTable('#tracking')) {
      $('#tracking').DataTable().destroy();
    }
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any) {
    if (form.valid) {
      this.ErrorHighlight = [];
      this.isValidate = true;
      // if (this.SummaryData.filter((e: any) =>
      //   e.CDesignationMasterId == null || e.CDutyMasterId == null
      //   || e.CDesignationMasterId == '' || e.CDutyMasterId == ''
      //   || e.CDesignationMasterId <= 0 || e.CDutyMasterId <= 0).length > 0) {
      //   this.toast.show({ message: 'Please select designation , duty or shift for all employee', type: toastTypeEnum.warning });
      // } else {
      // if (this.SummaryData.filter((e: any) => e.DesignationMasterId != e.CDesignationMasterId || e.DutyMasterId != e.CDutyMasterId).length > 0) {
      //   this.SummaryData.filter((e: any) => e.DesignationMasterId != e.CDesignationMasterId || e.DutyMasterId != e.CDutyMasterId).forEach((element: any) => {
      //     this.dateKeys.forEach((element2: any, index: number) => {
      //       if (this.updatedDatas.findIndex((e: any) => e.Index == index) < 0) {
      //         this.updatedDatas.push({
      //           DailyAttendanceInOutID: parseInt(element["DailyAttendanceInOutId_" + element2.replace(/\s+/g, '')]) || 0,
      //           EmpMasterId: element.EmpMasterId,
      //           DesignationMasterId: element.CDesignationMasterId,
      //           DutyMasterId: element.CDutyMasterId,
      //           ShiftMasterId: element.CShiftMasterId,
      //           AttendanceRemark: null,
      //           AttendanceDate: element2,
      //           OTHours: null,
      //           RelievingHours: null,
      //           IsUpdate: false,
      //         });
      //       }
      //     });
      //   });
      // }

      if (this.updatedDatas.length > 0) {
        //if (this.updatedDatas.findIndex((e: any) => e.ShiftMasterId == 0 || e.ShiftMasterId == null || e.ShiftMasterId == '') == -1) {
        if (this.updatedDatas.filter((e: any) => e.AttendanceRemark == '').length > 0) {
          this.updatedDatas.filter((e: any) => e.AttendanceRemark == '').forEach((element: any) => {
            const uvindex = this.SummaryData.findIndex((e: any) => e.EmpMasterId == element.EmpMasterId && e.DesignationMasterId == element.DesignationMasterId && e.DutyMasterId == element.DutyMasterId);
            if (uvindex >= 0) {
              if (this.SummaryData[uvindex]['B_' + element.AttendanceDate] != '' && this.SummaryData[uvindex]['B_' + element.AttendanceDate] != null) {
                this.isValidate = false;
                this.ErrorHighlight.push({
                  EmpMasterId: element.EmpMasterId,
                  DesignationMasterID: element.DesignationMasterId,
                  DutyMasterID: element.DutyMasterId,
                  AttendanceDate: element.AttendanceDate
                });

              }
            }
          });
        }

        if (this.isValidate) {
          this.ESS_SaveAttendanceOAS();
        } else if (!this.isValidate) {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = "Highlighter record attendance blank not allow, Set 'A' or other type";
          modalRef.result.then((result: any) => {
            this.musterSummaryComponent.ErrorHighlight = this.ErrorHighlight;
          });
        }
        // else {
        //   this.ESS_SaveAttendanceOAS();
        // }
        // } else {
        //   this.toast.show({ message: 'Please update shift for ' + this.SummaryData.filter((e: any) => e.EmpMasterId == this.updatedDatas[this.updatedDatas.findIndex((e: any) => e.ShiftMasterId == 0 || e.ShiftMasterId == null || e.ShiftMasterId == '')].EmpMasterId)[0].FullName, type: toastTypeEnum.warning });
        // }
      } else {
        this.toast.show({ message: 'No data found for update', type: toastTypeEnum.warning });
      }
      //}
      form.submitted = false;
    }
    else {
      form.submitted = true;
    }
  }

  async FilterValidate(form: any) {
    if (form.valid) {
      if (await this.SelectDate('RegistrationDate') && await this.ESS_GetCompanyParameterOAS()) {
        this.updatedDatas = [];
        this.ESS_LoadAttendanceOAS('POC');
        this.ESS_LoadAttendanceOAS('Summary');
        this.ESS_LoadAttendanceOAS('DS');
        this.ESS_LoadAttendanceOAS('DSB');
        this.ESS_LoadAttendanceOAS('Tracking');

        const dropdowndataindex = this.Dropdowns.findIndex((e: any) => e.SiteMasterID == this.filter.SiteMasterID);
        if (this.Dropdowns[dropdowndataindex]['BranchMasterID'] > 0) {
          this.filter.Branch = this.Dropdowns[dropdowndataindex]['BranchName'];
        }
        if (this.Dropdowns[dropdowndataindex]['ClientGroupMasterID'] > 0) {
          this.filter.Client = this.Dropdowns[dropdowndataindex]['ClientGroupName'];
        }
      }
    }
    else {
      form.submitted = true;
    }
  }

  ExcelDump() {
    if (this.filter.SiteMasterID > 0 && this.filter.MonthYear != null && this.filter.MonthYear != '') {
      this.ESS_AttendanceExcelDumpOAS('ED');
    } else {
      this.toast.show({ message: 'Please select site or month year', type: toastTypeEnum.warning });
    }
  }

  ESS_FillComboOAS() {
    this.isDisabled = true;
    this.resetAll();
    return this.musterAttendance.ESS_FillComboOAS({ 'SelectType': "FC", 'Flag': this.SiteStatus }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.Dropdowns = response.Table;
          this.Zones = [...new Map(this.Dropdowns.filter((e: any) => e.ZoneMasterID > 0).map((e: any) => ({ ZoneMasterID: e.ZoneMasterID, ZoneName: e.ZoneName })).map((item: any) => [item.ZoneMasterID, item])).values()];
          this.Clients = [...new Map(this.Dropdowns.filter((e: any) => e.ClientGroupMasterID > 0).map((e: any) => ({ ClientGroupMasterID: e.ClientGroupMasterID, ClientGroupName: e.ClientGroupName })).map((item: any) => [item.ClientGroupMasterID, item])).values()];
          this.Branchs = [...new Map(this.Dropdowns.filter((e: any) => e.BranchMasterID > 0).map((e: any) => ({ BranchMasterID: e.BranchMasterID, BranchName: e.BranchName })).map((item: any) => [item.BranchMasterID, item])).values()];
          this.Sectors = [...new Map(this.Dropdowns.filter((e: any) => e.SectorId > 0).map((e: any) => ({ SectorId: e.SectorId, SectorName: e.SectorName })).map((item: any) => [item.SectorId, item])).values()];
          this.Groups = [...new Map(this.Dropdowns.filter((e: any) => e.GroupId > 0).map((e: any) => ({ GroupId: e.GroupId, GroupName: e.GroupName })).map((item: any) => [item.GroupId, item])).values()];
          this.Sites = [...new Map(this.Dropdowns.filter((e: any) => e.SiteMasterID > 0).map((e: any) => ({ SiteMasterID: e.SiteMasterID, SiteName: e.SiteCode + '-' + e.SiteName, SiteCode: e.SiteCode })).map((item: any) => [item.SiteMasterID, item])).values()];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  DropdownChange(Key: String) {
    if (Key == 'Zone') {
      this.Sectors = [];
      this.filter.SectorId = null;
      this.Sectors = [...new Map(this.Dropdowns.filter((e: any) => (this.filter.ZoneMasterID > 0 ? e.ZoneMasterID == this.filter.ZoneMasterID : e) && e.SectorId > 0).map((e: any) => ({ SectorId: e.SectorId, SectorName: e.SectorName })).map((item: any) => [item.SectorId, item])).values()];
    }

    if (Key == 'Zone' || Key == 'Sector') {
      this.Groups = [];
      this.filter.GroupId = null;
      this.Groups = [...new Map(this.Dropdowns.filter((e: any) => (this.filter.ZoneMasterID > 0 ? e.ZoneMasterID == this.filter.ZoneMasterID : e) && (this.filter.SectorId > 0 ? e.SectorId == this.filter.SectorId : e) && e.GroupId > 0).map((e: any) => ({ GroupId: e.GroupId, GroupName: e.GroupName })).map((item: any) => [item.GroupId, item])).values()];
    }

    if (Key == 'Zone' || Key == 'Sector' || Key == 'Group') {
      this.Branchs = [];
      this.filter.BranchMasterID = null;
      this.Branchs = [...new Map(this.Dropdowns.filter((e: any) => (this.filter.ZoneMasterID > 0 ? e.ZoneMasterID == this.filter.ZoneMasterID : e) && (this.filter.SectorId > 0 ? e.SectorId == this.filter.SectorId : e) && (this.filter.GroupId > 0 ? e.GroupId == this.filter.GroupId : e) && e.BranchMasterID > 0).map((e: any) => ({ BranchMasterID: e.BranchMasterID, BranchName: e.BranchName })).map((item: any) => [item.BranchMasterID, item])).values()];
    }

    if (Key == 'Zone' || Key == 'Sector' || Key == 'Group' || Key == 'Branch') {
      this.Clients = [];
      this.filter.ClientGroupMasterID = null;
      this.Clients = [...new Map(this.Dropdowns.filter((e: any) => (this.filter.ZoneMasterID > 0 ? e.ZoneMasterID == this.filter.ZoneMasterID : e) && (this.filter.SectorId > 0 ? e.SectorId == this.filter.SectorId : e) && (this.filter.GroupId > 0 ? e.GroupId == this.filter.GroupId : e) && (this.filter.BranchMasterID > 0 ? e.BranchMasterID == this.filter.BranchMasterID : e) && e.ClientGroupMasterID > 0).map((e: any) => ({ ClientGroupMasterID: e.ClientGroupMasterID, ClientGroupName: e.ClientGroupName })).map((item: any) => [item.ClientGroupMasterID, item])).values()];
    }

    if (Key == 'Zone' || Key == 'Sector' || Key == 'Group' || Key == 'Branch' || Key == 'Client') {
      this.Sites = [];
      this.filter.SiteMasterID = null;
      this.Sites = [...new Map(this.Dropdowns.filter((e: any) => (this.filter.ZoneMasterID > 0 ? e.ZoneMasterID == this.filter.ZoneMasterID : e) && (this.filter.SectorId > 0 ? e.SectorId == this.filter.SectorId : e) && (this.filter.GroupId > 0 ? e.GroupId == this.filter.GroupId : e) && (this.filter.BranchMasterID > 0 ? e.BranchMasterID == this.filter.BranchMasterID : e) && (this.filter.ClientGroupMasterID > 0 ? e.ClientGroupMasterID == this.filter.ClientGroupMasterID : e) && e.SiteMasterID > 0).map((e: any) => ({ SiteMasterID: e.SiteMasterID, SiteName: e.SiteCode + '-' + e.SiteName, SiteCode: e.SiteCode })).map((item: any) => [item.SiteMasterID, item])).values()];
    }
  }

  ESS_LoadAttendanceOAS(SelectType: any): Promise<any> {
    this.isDisabled = true;
    if (SelectType == 'POC') {
      this.POCInfo.IsInternalPOCApplicable = false;
      this.POCInfo.IsClientPOCApplicable = false;
      this.POCInfo.SalaryStartDate = null;
      this.POCInfo.SalaryEndDate = null;
      this.POCInfo.IPOCAttachment = null;
    } else if (SelectType == 'Summary') {
      this.ErrorHighlight = [];
      this.POCInfo.InternalPOCStatus = null;
      this.POCInfo.ClientPOCStatus = null;
      this.POCInfo.IsLocked = false;
      this.POCInfo.IsReset = false;
      this.POCInfo.MonthlyAttachmentURL = null;
      this.POCInfo.BillingAttachmentURL = null;
      this.POCInfo.IsAttendanceLocked = false;

      this.SummaryData = [];
      this.dateKeys = [];
      this.LeaveBalance = [];
    } else if (SelectType == 'DS') {
      this.DesignationSummaryData = [];
    } else if (SelectType == 'DSB') {
      this.DesignationSummaryBillingData = [];
    } else if (SelectType == 'Tracking') {
      this.Tracking = [];
    }

    return new Promise((resolve, reject) => {
      this.musterAttendance.ESS_LoadAttendanceOAS({
        SelectType: SelectType, SiteId: this.filter.SiteMasterID,
        MonthName: this.dateFormate.fullmonth[this.filter.MonthYear.month - 1], YearName: this.filter.MonthYear.year,
        EmpMasterId: 0, AttendanceDate: '', DesignationMasterId: 0, DutyMasterId: 0, ShiftMasterId: 0,
      }).subscribe({
        next: (response) => {
          if (SelectType == 'POC') {
            if (response.Table) {
              this.POCInfo.IsInternalPOCApplicable = response.Table[0].IsInternalPOCApplicable;
              this.POCInfo.IsClientPOCApplicable = response.Table[0].IsClientPOCApplicable;
              this.POCInfo.SalaryStartDate = response.Table[0].SalaryStartDate;
              this.POCInfo.SalaryEndDate = response.Table[0].SalaryEndDate;
              this.POCInfo.IPOCAttachment = response.Table[0].IPOCAttachment;
              this.POCInfo.IPOCAttachmentURL = response.Table[0].IPOCAttachment;
            }
          } else if (SelectType == 'Summary') {
            if (response.Table && response.Table.length > 0) {
              this.POCInfo.InternalPOCStatus = response.Table[0].InternalPOCStatus;
              this.POCInfo.ClientPOCStatus = response.Table[0].ClientPOCStatus;
              this.POCInfo.IsLocked = response.Table[0].IsLocked;
              this.POCInfo.IsExcel = !response.Table[0].IsLocked;
              this.POCInfo.IsReset = response.Table[0].IsReset;
              this.POCInfo.IsAttendanceLocked = response.Table[0].IsAttendanceLocked;

              if (response.Table[0].MonthlyAttachmentURL != null && response.Table[0].MonthlyAttachmentURL != "") {
                this.POCInfo.MonthlyAttachmentURL = response.Table[0].MonthlyAttachmentURL;
              }
              if (response.Table[0].BillingAttachmentURL != null && response.Table[0].BillingAttachmentURL != "") {
                this.POCInfo.BillingAttachmentURL = response.Table[0].BillingAttachmentURL;
              }
            }

            if (response.Table1) {
              this.SummaryData = response.Table1;
              this.SummaryData = this.SummaryData.map((item: any) => {
                Object.keys(item).forEach(key => {
                  if (key.match(/^\d{2} \w{3} \d{4}$/) && !key.startsWith('B_')) {
                    item[`B_${key}`] = item[key];
                  }
                });
                return item;
              });
            }

            if (response.Table2) {
              this.LeaveBalance = response.Table2;
              this.LeaveBalance = this.LeaveBalance.map((item: any) => {
                Object.keys(item).forEach(key => {
                  if (key !== 'EmpMasterId' && key !== 'FullName') {
                    item[`B_${key}`] = item[key];
                  }
                });
                return item;
              });
            }
            
            if (this.musterSummaryComponent) {
              this.musterSummaryComponent.tableData = this.SummaryData;
              this.musterSummaryComponent.LeaveBalance = this.LeaveBalance;
              this.musterSummaryComponent.updatedDatas = this.updatedDatas;
              this.musterSummaryComponent.IsLocked = this.POCInfo.IsLocked;
              this.musterSummaryComponent.CompanyPermiter = this.CompanyPermiter;
              this.musterSummaryComponent.ErrorHighlight = this.ErrorHighlight;
              this.musterSummaryComponent.filter = this.filter;
              this.musterSummaryComponent.OnLoad();
            }
            this.dayKey();
          } else if (SelectType == 'DS') {
            if (response.Table) {
              this.DesignationSummaryData = response.Table;
            }
          } else if (SelectType == 'DSB') {
            if (response.Table) {
              this.DesignationSummaryBillingData = response.Table;
            }
          } else if (SelectType == 'Tracking') {
            if (response.Table) {
              this.Tracking = response.Table;
            }
            setTimeout(() => {
              if (this.Tracking.length > 0) {
                if (this.Tracking[this.Tracking.length - 1].ResetDate == null || this.Tracking[this.Tracking.length - 1].ResetDate == 'null') {
                  this.initializeDataTable('#tracking', Object.values([this.Tracking[this.Tracking.length - 1]]));
                } else {
                  this.initializeDataTable('#tracking', Object.values([]));
                }
              }
            }, 1);

          }

          this.setSelectType(this.filter.ListType);

          resolve(true);
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    });
  }

  ESS_AttendanceExcelDumpOAS(SelectType: string) {
    this.isDisabled = true;
    // this.SummaryData = [];
    // this.dateKeys = [];
    this.musterAttendance.ESS_AttendanceExcelDumpOAS({
      SelectType: SelectType, SiteId: this.filter.SiteMasterID,
      MonthName: this.dateFormate.fullmonth[this.filter.MonthYear.month - 1], YearName: this.filter.MonthYear.year,
    }).subscribe({
      next: (response) => {
        if (response.Table) {
          if (SelectType == 'ED') {
            this.ExcelData.Sheet1 = response.Table;

            this.ESS_AttendanceExcelDumpOAS('OT');
          } else if (SelectType == 'OT') {
            this.ExcelData.Sheet2 = response.Table;
            this.ESS_AttendanceExcelDumpOAS('RT');
          } else if (SelectType == 'RT') {
            this.ExcelData.Sheet3 = response.Table;

            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            if (this.ExcelData.Sheet1 && this.ExcelData.Sheet1.length) {
              const ws1 = XLSX.utils.json_to_sheet(this.ExcelData.Sheet1);
              XLSX.utils.book_append_sheet(wb, ws1, 'Sheet1');
            }

            if (this.ExcelData.Sheet2 && this.ExcelData.Sheet2.length) {
              const ws2 = XLSX.utils.json_to_sheet(this.ExcelData.Sheet2);
              XLSX.utils.book_append_sheet(wb, ws2, 'Sheet2');
            }

            if (this.ExcelData.Sheet3 && this.ExcelData.Sheet3.length) {
              const ws3 = XLSX.utils.json_to_sheet(this.ExcelData.Sheet3);
              XLSX.utils.book_append_sheet(wb, ws3, 'Sheet3');
            }

            XLSX.writeFile(wb, 'AttendanceData.xlsx');

          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  onNavigate(event: any) {
    this.filter.MonthYear = {
      "year": event.next.year,
      "month": event.next.month,
      "day": 1
    }
  }

  dayKey() {
    for (var key in this.SummaryData[0]) {
      // Check if the key is a date string (like "01 Aug 2025")
      if (key.match(/^\d{2} \w{3} \d{4}$/)) {
        this.dateKeys.push(key);
      }
    }
  };

  Empwisesummary(Index: number) {
    const modalRef = this.modalService.open(MusterAttendanceEmpWiseSummaryComponent, {
      size: 'xl',
      backdrop: 'static',
    });

    modalRef.componentInstance.tableData = this.SummaryData.map((e: any) => ({
      EmpMasterId: e.EmpMasterId,
      EmpCode: e.EmpCode,
      FullName: e.FullName,
      DesignationMasterId: e.DesignationMasterId,
      DutyMasterId: e.DutyMasterId,
      ShiftMasterId: e.ShiftMasterId,
      Photo: e.Photo,
      Gender: e.Gender,
    }));
    modalRef.componentInstance.Index = Index;
    modalRef.componentInstance.SiteMasterID = this.filter.SiteMasterID;
    modalRef.componentInstance.MonthYear = this.filter.MonthYear;
    modalRef.componentInstance.UpdateRecodes = JSON.parse(JSON.stringify(this.updatedDatas));
    modalRef.componentInstance.LeaveBalance = this.LeaveBalance;
    modalRef.componentInstance.IsLocked = this.POCInfo.IsLocked;
    modalRef.componentInstance.SiteName = this.Sites.filter((e: any) => e.SiteMasterID == this.filter.SiteMasterID)[0].SiteName;
    modalRef.componentInstance.CompanyPermiter = this.CompanyPermiter;
    modalRef.componentInstance.filter = this.filter;

    modalRef.result.then(
      (result: any) => {
        if (result) {
          if (result.length > 0) {
            result.filter((e: any) => e.IsUpdate).forEach((element: any) => {
              element.IsUpdate = false;

              const index = this.SummaryData.findIndex((e: any) => e.EmpMasterId == element.EmpMasterId && e.DesignationMasterId == element.DesignationMasterId && e.DutyMasterId == element.DutyMasterId);
              if (index >= 0) {
                this.SummaryData[index][element.AttendanceDate] = element.AttendanceRemark;
              }

              const index2 = this.updatedDatas.findIndex((e: any) => e.EmpMasterId == element.EmpMasterId && e.DesignationMasterId == element.DesignationMasterId && e.DutyMasterId == element.DutyMasterId && e.AttendanceDate == element.AttendanceDate);
              if (index2 >= 0) {
                this.updatedDatas[index2].AttendanceRemark = element.AttendanceRemark;
                this.updatedDatas[index2].ShiftMasterId = element.ShiftMasterId;
                this.updatedDatas[index2].OTHours = element.OTHours;
                this.updatedDatas[index2].RelievingHours = element.RelievingHours;
              } else {
                this.updatedDatas.push(element);
              }
            });
          }
        } else if (result == null) {
          this.ESS_LoadAttendanceOAS('Summary');
        }
      },
      () => { }
    );
  }

  Datewisesummary(Index: number) {
    const modalRef = this.modalService.open(MusterAttendanceDateWiseSummaryComponent, {
      size: 'xl',
      backdrop: 'static',
      centered: true,
    });
    modalRef.componentInstance.dateKeys = this.dateKeys;
    modalRef.componentInstance.Index = Index;
    modalRef.componentInstance.SiteMasterID = this.filter.SiteMasterID;
    modalRef.componentInstance.UpdateRecodes = JSON.parse(JSON.stringify(this.updatedDatas));
    modalRef.componentInstance.LeaveBalance = this.LeaveBalance;
    modalRef.componentInstance.IsLocked = this.POCInfo.IsLocked;
    modalRef.componentInstance.SiteName = this.Sites.filter((e: any) => e.SiteMasterID == this.filter.SiteMasterID)[0].SiteName;
    modalRef.componentInstance.CompanyPermiter = this.CompanyPermiter;
    modalRef.componentInstance.filter = this.filter;

    modalRef.result.then(
      (result: any) => {
        if (result) {
          if (result.length > 0) {
            result.filter((e: any) => e.IsUpdate).forEach((element: any) => {
              element.IsUpdate = false;

              const index = this.SummaryData.findIndex((e: any) => e.EmpMasterId == element.EmpMasterId && e.DesignationMasterId == element.DesignationMasterId && e.DutyMasterId == element.DutyMasterId);
              if (index >= 0) {
                this.SummaryData[index][element.AttendanceDate] = element.AttendanceRemark;
              }

              const index2 = this.updatedDatas.findIndex((e: any) => e.EmpMasterId == element.EmpMasterId && e.DesignationMasterId == element.DesignationMasterId && e.DutyMasterId == element.DutyMasterId && e.AttendanceDate == element.AttendanceDate);
              if (index2 >= 0) {
                this.updatedDatas[index2].AttendanceRemark = element.AttendanceRemark;
                this.updatedDatas[index2].ShiftMasterId = element.ShiftMasterId;
                this.updatedDatas[index2].OTHours = element.OTHours;
                this.updatedDatas[index2].RelievingHours = element.RelievingHours;
              } else {
                this.updatedDatas.push(element);
              }
            });
          }
        }
      },
      () => { }
    );
  }

  DayChange(data: any) {
    const index = this.SummaryData.findIndex((e: any) => e.EmpMasterId == data.EmpMasterId && e.DesignationMasterId == data.DesignationMasterId && e.DutyMasterId == data.DutyMasterId && e.ShiftMasterId == data.ShiftMasterId);
    if (index >= 0) {
      this.SummaryData[index][data.AttendanceDate] = data.AttendanceRemark;
    }

    const index2 = this.updatedDatas.findIndex((e: any) => e.EmpMasterId == data.EmpMasterId && e.DesignationMasterId == data.DesignationMasterId && e.DutyMasterId == data.DutyMasterId && e.ShiftMasterId == data.ShiftMasterId && e.AttendanceDate == data.AttendanceDate);
    if (index2 >= 0) {
      this.updatedDatas[index2].AttendanceRemark = data.AttendanceRemark;
    } else {
      this.updatedDatas.push(data);
    }
  }

  ESS_SaveAttendanceOAS() {
    this.ErrorHighlight = [];
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        this.filter.ESS_SaveAttendance_OAS = [];
        this.updatedDatas.filter((e: any) => e.AttendanceRemark != '' && e.AttendanceRemark != null).forEach((element: any) => {
          const uindex = this.SummaryData.findIndex((e: any) => e.EmpMasterId == element.EmpMasterId && e.DesignationMasterId == element.DesignationMasterId && e.DutyMasterId == element.DutyMasterId);
          if (uindex >= 0 && this.common.ToLowerCase(
            this.SummaryData[uindex]['B_' + element.AttendanceDate]) != this.common.ToLowerCase(element.AttendanceRemark)
          ) {
            this.filter.ESS_SaveAttendance_OAS.push(
              {
                DailyAttendanceInOutId: element.DailyAttendanceInOutID,
                EmpMasterId: element.EmpMasterId,
                DesignationId: element.DesignationMasterId,
                DutyId: element.DutyMasterId,
                ShiftMasterId: element.ShiftMasterId,
                AttendanceDate: element.AttendanceDate,
                AttendanceRemark: element.AttendanceRemark,
                BillableOT: element.OTHours,
                NonBillableOT: element.RelievingHours,
              }
            );
          }
        });

        if (this.filter.ESS_SaveAttendance_OAS.length > 0) {
          this.musterAttendance.ESS_SaveAttendanceOAS({
            'SelectType': 'i', SiteId: this.filter.SiteMasterID, ESS_SaveAttendance_OAS: this.filter.ESS_SaveAttendance_OAS
          }).subscribe({
            next: (response) => {
              if (response.Error_Code == '755') {
                this.filter.ESS_SaveAttendance_OAS = [];
                this.updatedDatas = [];

                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.ESS_LoadAttendanceOAS('POC');
                    this.ESS_LoadAttendanceOAS('Summary');
                    this.ESS_LoadAttendanceOAS('DS');
                    this.ESS_LoadAttendanceOAS('DSB');
                    this.ESS_LoadAttendanceOAS('Tracking');
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                if (response.Error_Code == '280' && response.table.Table.length > 0) {
                  modalRef.componentInstance.Message2 = `
                          <table class="table" style="font-size: x-small;">
                              <thead>
                                  <tr>
                                      <th>Name</th>
                                      <th>Available Leave</th>
                                      <th>Leave Type</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  ${response.table.Table.map((item: any) => `
                                      <tr>
                                          <td>${item.EmpCode} - ${item.FullName}</td>
                                          <td class='text-end'>${item.LeaveBalance}</td>
                                          <td class='text-center'>${item.LeaveFlag}</td>
                                      </tr>
                                  `).join('')}
                              </tbody>
                          </table>
                          `;
                } else if (response.Error_Code == '916' && response.table.Table.length > 0) {
                  modalRef.componentInstance.Message2 = `
                          <table class="table" style="font-size: x-small;">
                              <thead>
                                  <tr>
                                      <th>Name</th>
                                      <th>Leave Type</th>
                                      <th>Date</th>
                                      <th>Days</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  ${response.table.Table.map((item: any) => `
                                      <tr>
                                          <td>${item.EmpCode} - ${item.EmpName}</td>
                                          <td class='text-center'>${item.LeaveFlag}</td>
                                          <td class='text-center'>${item.FromDate} <b>To</b> <br/> ${item.ToDate}</td>
                                          <td class='text-center'>${item.NoOfDays}</td>
                                      </tr>
                                  `).join('')}
                              </tbody>
                          </table>
                          `;
                }
                modalRef.result.then((result: any) => {
                  if (response.Error_Code == '767' || response.Error_Code == '280') {
                    if (response.table.Table.length > 0) {
                      this.ErrorHighlight = response.table.Table;
                      this.musterSummaryComponent.ErrorHighlight = this.ErrorHighlight;
                    }
                  } else if (response.Error_Code == '916') {
                    if (response.table.Table.length > 0) {
                      response.table.Table.forEach((element: any) => {
                        this.SummaryData.filter((e: any) => e.EmpMasterId == element.EmpMasterId).forEach((element3: any) => {
                          this.common.getDateRangeFormatted(new Date(element.FromDate), new Date(element.ToDate)).forEach(element2 => {
                            this.ErrorHighlight.push({
                              EmpMasterId: element.EmpMasterId,
                              DesignationMasterID: element3.DesignationMasterId,
                              DutyMasterID: element3.DutyMasterId,
                              AttendanceDate: element2
                            });
                          });
                        });
                      });
                      this.musterSummaryComponent.ErrorHighlight = this.ErrorHighlight;
                    }
                  }
                });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        } else {
          this.isDisabled = false;
          this.toast.show({ message: 'No data found for update', type: toastTypeEnum.warning });
        }
      }
    });
  }

  upload(event: any) {
    if (this.filter.SiteMasterID > 0 && this.filter.MonthYear != null && this.filter.MonthYear != '') {
      const files: FileList = event.target.files;
      if (files && files.length > 0) {
        const file: File = files[0];
        const fileType: string | undefined = file.name.split('.').pop();
        if (fileType !== 'xlsx' && fileType !== 'xls') {
          this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
          return;
        }
        this.processExcelFile(file);
        event.target.value = '';
      }
    } else {
      this.toast.show({ message: 'Please select site and month year', type: toastTypeEnum.warning });
    }
  }

  async processExcelFile(file: File): Promise<void> {
    this.SummaryData = [];
    this.musterSummaryComponent.tableData = [];
    this.dateKeys = [];

    if (await this.SelectDate('RegistrationDate') && await this.ESS_GetCompanyParameterOAS()) {
      if (await this.ComboLoadAsync('Attendance Type') && await this.ESS_LoadAttendanceOAS('POC') && await this.ESS_LoadAttendanceOAS('Summary') && await this.ESS_LoadAttendanceOAS('DS') && await this.ESS_LoadAttendanceOAS('DSB') && await this.ESS_LoadAttendanceOAS('Tracking')) {
        const reader = new FileReader();
        reader.onload = async (event) => {
          if (event && event.target && event.target.result) {
            const binaryString = event.target.result as string;
            const workbook = XLSX.read(binaryString, { type: 'binary' });
            const sheetName1 = 'Sheet1';
            const sheetName2 = 'Sheet2';
            const sheetName3 = 'Sheet3';

            if (!workbook.SheetNames.includes(sheetName1)) {
              const errorMessage = 'Sheet1 not found in the uploaded file.';
              this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
              return;
            }

            if (!workbook.SheetNames.includes(sheetName2)) {
              const errorMessage = 'Sheet2 not found in the uploaded file.';
              this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
              return;
            }

            if (!workbook.SheetNames.includes(sheetName3)) {
              const errorMessage = 'Sheet3 not found in the uploaded file.';
              this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
              return;
            }

            const worksheet = workbook.Sheets[sheetName1];
            const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
            const excelData2 = (XLSX.utils.sheet_to_json(workbook.Sheets[sheetName2], { header: 1 }) as any[][]);
            const excelData3 = (XLSX.utils.sheet_to_json(workbook.Sheets[sheetName3], { header: 1 }) as any[][]);

            // const headerRow = excelData[0];
            // const headers = headerRow.map((header: string) => header.trim());
            const dataRows = excelData.slice(1);
            const dataRows2 = excelData2.slice(1);
            const dataRows3 = excelData3.slice(1);

            excelData[0].forEach(element => {
              const cleanedKey = element.trim();
              if (cleanedKey.match(/^\d{2} \w{3} \d{4}$/)) {
                this.dateKeys.push(cleanedKey);
              }
            });

            for (let rowIndex = 0; rowIndex < dataRows.length; rowIndex++) {
              const row = dataRows[rowIndex];
              let row2: any[] = [];
              let row3: any[] = [];

              dataRows2.forEach(element => {
                if (
                  element[excelData2[0].findIndex(col => this.common.ToLowerCase(col) === 'empmasterid')] == row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'empmasterid')]
                  && element[excelData2[0].findIndex(col => this.common.ToLowerCase(col) === 'designationmasterid')] == row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'designationmasterid')]
                  && element[excelData2[0].findIndex(col => this.common.ToLowerCase(col) === 'dutymasterid')] == row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'dutymasterid')]
                ) {
                  row2 = element;
                }
              });

              dataRows3.forEach(element => {
                if (
                  element[excelData3[0].findIndex(col => this.common.ToLowerCase(col) === 'empmasterid')] == row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'empmasterid')]
                  && element[excelData3[0].findIndex(col => this.common.ToLowerCase(col) === 'designationmasterid')] == row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'designationmasterid')]
                  && element[excelData3[0].findIndex(col => this.common.ToLowerCase(col) === 'dutymasterid')] == row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'dutymasterid')]
                ) {
                  row3 = element;
                }
              });

              // const dateFields = this.dateKeys.reduce((acc: any, key: any) => {
              //   acc[key] = row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === this.common.ToLowerCase(key))];
              //   return acc;
              // }, {} as Record<string, string>);

              const index = this.SummaryData.findIndex((e: any) => e.EmpMasterId == row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'empmasterid')]
                && e.DesignationMasterId == row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'designationmasterid')]
                && e.DutyMasterId == row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'dutymasterid')]);

              if (index >= 0) {

                await this.ComboLoadAsync("ShiftLoadBasedOnDesignationDuty", index);
                let ShiftMasterID = null as any;

                if (this.SummaryData[index].Shifts.filter((e: any) => e.ShiftCode == row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'shiftcode')]).length > 0) {
                  ShiftMasterID = this.SummaryData[index].Shifts.filter((e: any) => e.ShiftCode == row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'shiftcode')])[0].ShiftMasterID;
                }

                this.dateKeys.forEach((element: string) => {
                  const indexupd = this.updatedDatas.findIndex((e: any) => e.EmpMasterId == row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'empmasterid')]
                    && e.DesignationMasterId == row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'designationmasterid')]
                    && e.DutyMasterId == row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'dutymasterid')]
                    //&& e.ShiftMasterId == row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'shiftmasterid')]
                    && e.AttendanceDate == element);
                  const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, element);
                  if ((difDay == 0
                    || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
                    || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
                    && !this.POCInfo.IsLocked) {
                    if (this.SummaryData[index]['IsAttendanceAllowed_' + element.replace(/\s+/g, '')] && this.CheckJoinLeftDate(element, this.SummaryData[index].JoiningDate, this.SummaryData[index].LeftDate) && !this.POCInfo.IsLocked) {

                      try {
                        if (this.AttendanceTypes.map((e: any) => e.AttendanceTypeCode.toUpperCase()).some((code: any) => code.includes((row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === this.common.ToLowerCase(element))]).toUpperCase()))) {
                          this.SummaryData[index][element] = row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === this.common.ToLowerCase(element))];
                          if (indexupd == -1) {
                            this.updatedDatas.push({
                              DailyAttendanceInOutID: null,
                              EmpMasterId: this.SummaryData[index].EmpMasterId,
                              DesignationMasterId: this.SummaryData[index].DesignationMasterId,
                              DutyMasterId: this.SummaryData[index].DutyMasterId,
                              ShiftMasterId: ShiftMasterID,
                              AttendanceRemark: this.SummaryData[index][element],
                              B_AttendanceRemark: this.SummaryData[index][element],
                              AttendanceDate: element,
                              OTHours: row2[excelData2[0].findIndex(col => this.common.ToLowerCase(col) === "ot_" + this.common.ToLowerCase(element))],
                              RelievingHours: row3[excelData3[0].findIndex(col => this.common.ToLowerCase(col) === "rt_" + this.common.ToLowerCase(element))],
                              IsUpdate: false,
                              IsExcel: true,
                            });
                          } else if (indexupd >= 0) {
                            this.updatedDatas[indexupd].AttendanceRemark = this.SummaryData[index][element];
                            this.updatedDatas[indexupd].ShiftMasterId = ShiftMasterID;
                            this.updatedDatas[indexupd].OTHours = row2[excelData2[0].findIndex(col => this.common.ToLowerCase(col) === "ot_" + this.common.ToLowerCase(element))];
                            this.updatedDatas[indexupd].RelievingHours = row3[excelData3[0].findIndex(col => this.common.ToLowerCase(col) === "rt_" + this.common.ToLowerCase(element))];
                            this.updatedDatas[indexupd].IsUpdate = false;
                            this.updatedDatas[indexupd].IsExcel = true;
                          }
                        }
                      } catch (e) {

                      }
                    }
                  }
                });
              }

              // this.SummaryData.push({
              //   EmpMasterId: row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'empmasterid')],
              //   EmpCode: row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'empcode')],
              //   FullName: row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'fullname')],
              //   Photo: null,
              //   Gender: null,
              //   DesignationMasterId: row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'designationmasterid')],
              //   DesignationName: row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'designationname')],
              //   DutyMasterId: row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'dutymasterid')],
              //   DutyName: row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'dutyname')],
              //   ShiftMasterId: row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'shiftmasterid')],
              //   ShiftCode: row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'shiftcode')],
              //   ShiftTitle: row[excelData[0].findIndex(col => this.common.ToLowerCase(col) === 'shifttitle')],
              //   ...dateFields
              // })
            }

            // this.musterSummaryComponent.tableData = this.SummaryData;
            // this.musterSummaryComponent.IsLocked = this.POCInfo.IsLocked;
            // this.musterSummaryComponent.OnLoad();
            if (this.musterSummaryComponent) {
              this.musterSummaryComponent.tableData = this.SummaryData;
              this.musterSummaryComponent.updatedDatas = this.updatedDatas;
              this.musterSummaryComponent.IsLocked = this.POCInfo.IsLocked;
              this.musterSummaryComponent.OnLoad();
            }
          } else {
            console.error('Failed to read the file.');
          }
        };
        reader.readAsBinaryString(file);
      }
    }
  }

  SendPOC(Type: any) {
    if ((Type == 'I' && this.POCInfo.IsInternalPOCApplicable && (this.POCInfo.InternalPOCStatus == null || this.POCInfo.InternalPOCStatus == '' || this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) == 'rejected'))
      || (Type == 'C' && this.POCInfo.IsClientPOCApplicable && (!this.POCInfo.IsInternalPOCApplicable || this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) == 'approved') &&
        (this.POCInfo.ClientPOCStatus == null || this.POCInfo.ClientPOCStatus == '')))
      if (this.filter.SiteMasterID > 0 && this.filter.MonthYear != null && this.filter.MonthYear != "") {
        const modalRef = this.modalService.open(MusterAttendanceSendPOCComponent, {
          size: 'xl',
          backdrop: 'static',
        });
        modalRef.componentInstance.SiteMasterID = this.filter.SiteMasterID;
        modalRef.componentInstance.MonthYear = this.filter.MonthYear;
        modalRef.componentInstance.Type = Type;
        modalRef.componentInstance.SiteName = this.Sites.filter((e: any) => e.SiteMasterID == this.filter.SiteMasterID)[0].SiteName;
        modalRef.result.then(
          (result: any) => {
            if (result) {
              this.ESS_LoadAttendanceOAS('POC');
              this.ESS_LoadAttendanceOAS('Summary');
              this.ESS_LoadAttendanceOAS('Tracking');
            }
          }
        );
      } else {
        this.toast.show({ message: 'Please select site and month year', type: toastTypeEnum.warning });
      }
  }

  initializeDataTable(selector: string, data: any[]) {
    if (selector == "#designationWiseSummarydata") {
      if (this.filter.ListType == 1) {
        this.dtOptions.columns = [
          {
            title: '#',
            data: null,
            render: (data: any, type: any, row: any, meta: any) => {
              return `<strong>${meta.row + (meta.settings.displayStart ?? 0) + 1}</strong>`;
            },
            orderable: true,
          },
          {
            title: 'Designation',
            data: 'DesignationName',
            orderable: true,
          },
          {
            title: 'Duty',
            data: 'DutyName',
            orderable: true,
          },
          {
            title: 'Total Strength (AsPerContract)',
            data: 'TotalStrengthAsPerContract',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'ManDays (AsPerContract)',
            data: 'TotalMandaysAsPerContract',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'Total Strength (AsPerAttendance)',
            data: 'TotalStrengthAsPerAttendance',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'ManDays (AsPerAttendance)',
            data: 'TotalMandaysAsPerAttendance',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'Extra Shifts Not Billed',
            data: 'ExtraShiftsNotBilled',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'OT Days',
            data: 'OTDays',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'Relieving Days',
            data: 'RelievingDays',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'Total Leave',
            data: 'TotalLeave',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'Week Off',
            data: 'WeekOff',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'Paid Holiday',
            data: 'PaidHoliday',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'Total Working days',
            data: 'TotalWorkingDays',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'Calculation On',
            data: 'CalculationOn',
            orderable: true,
            className: 'column-text text-center'
          },
        ]
      } else if (this.filter.ListType == 2) {
        this.dtOptions.columns = [
          {
            title: '#',
            data: null,
            render: (data: any, type: any, row: any, meta: any) => {
              return `<strong>${meta.row + (meta.settings.displayStart ?? 0) + 1}</strong>`;
            },
            orderable: true,
          },
          {
            title: 'Designation',
            data: 'DesignationName',
            orderable: true,
          },
          {
            title: 'Duty',
            data: 'DutyName',
            orderable: true,
          },
          {
            title: 'Total Strength (AsPerContract)',
            data: 'TotalStrengthAsPerContract',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'ManDays (AsPerContract)',
            data: 'TotalMandaysAsPerContract',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'Total Strength (AsPerAttendance)',
            data: 'TotalStrengthAsPerAttendance',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'ManDays (AsPerAttendance)',
            data: 'TotalMandaysAsPerAttendance',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'Extra Shifts Not Billed',
            data: 'ExtraShiftsNotBilled',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'OT Days',
            data: 'OTDays',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'Relieving Days',
            data: 'RelievingDays',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'Total Leave',
            data: 'TotalLeave',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'Week Off',
            data: 'WeekOff',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'Paid Holiday',
            data: 'PaidHoliday',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'Total Working days',
            data: 'TotalWorkingDays',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'Calculation On',
            data: 'CalculationOn',
            orderable: true,
            className: 'column-text text-center'
          },
          {
            title: 'IsLeave Included',
            data: 'IsLeaveIncluded',
            orderable: true,
            className: 'column-text text-center'
          },
        ]
      }
    }


    if ($.fn.dataTable.isDataTable(selector)) {
      $(selector).DataTable().clear().destroy();
      $(selector).empty();
    }

    if (selector == "#designationWiseSummarydata") {
      const table = $(selector).DataTable({
        data: data,
        ...this.dtOptions
      });
    } else if (selector == "#tracking") {
      const table = $(selector).DataTable({
        data: data,
        ...this.dtOptionsTracking
      });
    } else if (selector == "#pocdata") {
      const table = $(selector).DataTable({
        data: data,
        ...this.dtOptionsPOC
      });
    }

  }

  async ResetPOC(Type: string) {
    if (Type == 'Lock') {
      this.IsAllow = false;
    } else {
      this.IsAllow = true;
    }
    if ((Type == 'Reset' && this.POCInfo.IsLocked && this.CompanyPermiter.IsAttendanceResetAllowed) || (Type == 'Lock' && !this.POCInfo.IsLocked && !this.POCInfo.IsInternalPOCApplicable && !this.POCInfo.IsClientPOCApplicable)) {
      if (Type == 'Reset' || (Type == 'Lock' && await this.CheckUnmatchRecodeFromDesignationSummary())) {
        if (Type == 'Lock') {
          this.IsAllow = await this.ESS_ValidateSaveAttendanceOAS('SiteLockValidation');
        }

        if (this.IsAllow) {
          const modalRef = this.modalService.open(ConfirmationComponent);
          modalRef.componentInstance.Message = 'Do you want to ' + Type + '?';
          modalRef.result.then(result => {
            if (result) {
              this.isDisabled = true;
              this.musterAttendance.ESS_SiteWiseAttendanceSendToPOCOAS({
                SelectType: Type, SiteId: this.filter.SiteMasterID, MonthName: this.dateFormate.fullmonth[this.filter.MonthYear.month - 1], YearName: this.filter.MonthYear.year, MailId: null as any, ApprovalStatus: null,
              }).subscribe({
                next: (response) => {
                  if (response.Error_Code == '760' || response.Error_Code == '765') {
                    const modalRef = this.modalService.open(AlertSuccessComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => {
                      if (result) {
                        this.ESS_LoadAttendanceOAS('POC');
                        this.ESS_LoadAttendanceOAS('Summary');
                        this.ESS_LoadAttendanceOAS('Tracking');
                      }
                    });
                  } else {
                    const modalRef = this.modalService.open(AlertWarningComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => { });
                  }
                  this.isDisabled = false;
                },
                complete: () => { },
                error: (error) => {
                  this.isDisabled = false;
                },
              });
            }
          });
        }

      } else {
        const modalRef = this.modalService.open(AlertWarningComponent, {
          size: 'md',
          backdrop: 'static',
          centered: true,
          windowClass: 'confirmation-modal'
        });
        modalRef.componentInstance.Message = "Highlighter recode attendance designation not match with designation summary";
        modalRef.result.then((result: any) => { });
      }
    }
  }

  DesignationSummaryEdit() {
    if (this.filter.ListType == 2 && this.DesignationSummaryBillingData.length > 0 && !this.POCInfo.IsLocked) {
      const modalRef = this.modalService.open(DesignationSummaryFormComponent, {
        size: 'xl',
        backdrop: 'static',
      });
      modalRef.componentInstance.DesignationSummaryBillingData = this.DesignationSummaryBillingData.filter((e: any) => e.TotalWorkingDays > 0);
      modalRef.componentInstance.SiteName = this.Sites.filter((e: any) => e.SiteMasterID == this.filter.SiteMasterID)[0].SiteName;
      modalRef.result.then(
        (result: any) => {
          if (result) {
            this.ESS_LoadAttendanceOAS('DSB');
          }
        }
      );
    }
  }

  ComboLoadAsync(Combotype: string, Index = 0): Promise<any> {
    this.isDisabled = true;
    if (Combotype == "ShiftLoadBasedOnDesignationDuty") {
      this.SummaryData[Index].Shifts = [];
    } else if (Combotype == "Attendance Type") {
      this.AttendanceTypes = [];
    }

    return new Promise((resolve, reject) => {
      this.combo.ComboLoad({
        Combotype: Combotype,
        EmpMasterID: this.user.UserId,
        SiteId: this.filter.SiteMasterID,
        DesignationId: Combotype == "Attendance Type" ? 0 : this.SummaryData[Index].DesignationMasterId,
        DutyId: Combotype == "Attendance Type" ? 0 : this.SummaryData[Index].DutyMasterId,
      }).subscribe({
        next: (response) => {
          if (Combotype === 'ShiftLoadBasedOnDesignationDuty') {
            this.SummaryData[Index].Shifts = response.ComboLoad;
          } else if (Combotype == 'Attendance Type') {
            this.AttendanceTypes = response.ComboLoad;
          }
          this.isDisabled = false;
          resolve(true); // Resolve after data is loaded
        },
        error: (err) => {
          this.isDisabled = false;
          reject(err);
        }
      });
    });
  }

  CheckJoinLeftDate(Day: any, JoiningDate: any, LeftDate: any) {
    return new Date(Day).getTime() >= new Date(JoiningDate).getTime() && (LeftDate == null || new Date(Day).getTime() <= new Date(LeftDate).getTime());
  }

  setSelectType(index: number) {
    this.filter.ListType = index;
    if (index == 1) {
      this.initializeDataTable('#designationWiseSummarydata', Object.values(this.DesignationSummaryData));
    } else if (index == 2) {
      this.initializeDataTable('#designationWiseSummarydata', Object.values(this.DesignationSummaryBillingData));
    }
  }

  async openSPOC(Type: string, content: TemplateRef<any>) {
    this.POCFilter.MailIds = null;
    this.POCFilter.MailId = null;
    this.POCFilter.IsMonthlySummary = true;
    this.POCFilter.IsBillingSummary = true;
    if ((Type == 'I' && this.POCInfo.IsInternalPOCApplicable && (this.POCInfo.InternalPOCStatus == null || this.POCInfo.InternalPOCStatus == '' || this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) == 'pending' || this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) == 'rejected'))
      || (Type == 'C' && this.POCInfo.IsClientPOCApplicable && (!this.POCInfo.IsInternalPOCApplicable || this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) == 'approved') &&
        (this.POCInfo.ClientPOCStatus == null || this.POCInfo.ClientPOCStatus == '' || this.common.ToLowerCase(this.POCInfo.ClientPOCStatus) == 'pending')))
      if (this.filter.SiteMasterID > 0 && this.filter.MonthYear != null && this.filter.MonthYear != "") {
        if (await this.CheckUnmatchRecodeFromDesignationSummary()) {
          this.ESS_LoadAttendanceOASPOC(Type, content);
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = "Highlighter recode attendance designation not match with designation summary";
          modalRef.result.then((result: any) => { });
        }
      } else {
        this.toast.show({ message: 'Please select site and month year', type: toastTypeEnum.warning });
      }
  }

  ESS_LoadAttendanceOASPOC(Type: string, content: TemplateRef<any>) {
    this.isDisabled = true;
    this.PocDatas = [];
    this.musterAttendance.ESS_LoadAttendanceOAS({
      'SelectType': 'POC', SiteId: this.filter.SiteMasterID,
      MonthName: this.dateFormate.fullmonth[this.filter.MonthYear.month - 1], YearName: this.filter.MonthYear.year,
      EmpMasterId: 0, AttendanceDate: null, DesignationMasterId: 0, DutyMasterId: 0, ShiftMasterId: 0,
    }).subscribe({
      next: (response) => {
        if (response.Table) {
          if (Type == 'I' && !this.POCInfo.IsInternalPOCApplicable) {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = "Internal POC Not Allow";
            modalRef.result.then((result: any) => { });
          } else if (Type == 'C' && !this.POCInfo.IsClientPOCApplicable) {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = "Client POC Not Allow";
            modalRef.result.then((result: any) => { });
          } else {
            this.Type = Type;
            this.PocDatas = response.Table;
            this.SPocServiceRef = this.SPocService.open(content, { position: 'end' });
          }
        }
        this.initializeDataTable('#pocdata', Object.values(this.PocDatas));
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ValidatePOC(form: any) {
    this.IsAllow = false
    if (form.valid) {
      if (this.POCFilter.IsMonthlySummary || this.POCFilter.IsBillingSummary) {
        if (this.POCFilter.MailIds == null || this.POCFilter.MailIds == "") {
          this.POCFilter.MailId = this.PocDatas.filter((e: any) => e.selected).map((e: any) => this.Type == 'I' ? e.InternalPOCMailId : e.ClientPOCMailId).toString();
        } else {
          this.POCFilter.MailId = this.POCFilter.MailIds + ',' + this.PocDatas.filter((e: any) => e.selected).map((e: any) => this.Type == 'I' ? e.InternalPOCMailId : e.ClientPOCMailId).toString();
        }
        if (this.POCFilter.MailId != null && this.POCFilter.MailId != "") {
          this.IsAllow = await this.ESS_ValidateSaveAttendanceOAS('SiteLockValidation');
          if (this.IsAllow) {
            const modalRef = this.modalService.open(ConfirmationComponent);
            modalRef.componentInstance.Message = 'Do you want to send ' + (this.Type == 'I' ? 'Internal' : this.Type == 'C' ? 'Client' : '') + '?';
            modalRef.result.then(result => {
              if (result) {
                this.ESS_SiteWiseAttendanceSendToPOCOAS();
              }
            });
          }
        } else {
          this.toast.show({ message: 'Please select emailid or enter emailid.', type: toastTypeEnum.danger });
        }
      } else {
        this.toast.show({ message: 'Please select atleast one monthly summary or billing summary.', type: toastTypeEnum.danger });
      }
    }
    else {
      form.submitted = true;
    }
  }

  ESS_SiteWiseAttendanceSendToPOCOAS() {
    this.isDisabled = true;

    this.POCFilter.SelectType = this.Type == 'I' ? 'IPOC' : 'CPOC';
    this.POCFilter.SiteId = this.filter.SiteMasterID;
    this.POCFilter.SiteCode = this.Sites.filter((e: any) => e.SiteMasterID == this.filter.SiteMasterID)[0].SiteCode,
      this.POCFilter.SiteName = this.Sites.filter((e: any) => e.SiteMasterID == this.filter.SiteMasterID)[0].SiteName,
      this.POCFilter.MonthName = this.dateFormate.fullmonth[this.filter.MonthYear.month - 1];
    this.POCFilter.YearName = this.filter.MonthYear.year;
    this.POCFilter.CompanyCode = this.user.CompanyCode;
    this.POCFilter.CompanyName = this.user.CompanyName,
      this.POCFilter.DomainName = this.user.Domain;
    this.POCFilter.IPOCAttachment = this.Type == 'I' ? this.POCInfo.IPOCAttachmentURL : null;

    this.musterAttendance.ESS_SiteWiseAttendanceSendToPOCOAS(this.POCFilter).subscribe({
      next: (response) => {
        if (response.Error_Code == '01') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.SPocServiceRef?.close();
              this.ESS_LoadAttendanceOAS('POC');
              this.ESS_LoadAttendanceOAS('Summary');
              this.ESS_LoadAttendanceOAS('Tracking');
            }
          });
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_GetCompanyParameterOAS(): Promise<any> {
    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.musterAttendance.ESS_GetCompanyParameterOAS({ SelecType: 'cp', SiteId: this.filter.SiteMasterID }).subscribe({
        next: (response) => {
          if (response.Table) {
            this.CompanyPermiter.IsAttendanceBeforeDaysAllowed = response.Table[0].IsAttendanceBeforeDaysAllowed;
            this.CompanyPermiter.AttendanceBeforeDays = response.Table[0].AttendanceBeforeDays;
            this.CompanyPermiter.IsAttendanceAfterDaysAllowed = response.Table[0].IsAttendanceAfterDaysAllowed;
            this.CompanyPermiter.AttendanceAfterDays = response.Table[0].AttendanceAfterDays;
            this.CompanyPermiter.IsUpdateDesignationDutyAllowed = response.Table[0].IsUpdateDesignationDutyAllowed;
            this.CompanyPermiter.IsAttendanceResetAllowed = response.Table[0].IsAttendanceResetAllowed;
            this.CompanyPermiter.IsAttendanceDeleteAllowed = response.Table[0].IsAttendanceDeleteAllowed;
            this.CompanyPermiter.IsAttendanceForSameDayAllowed = response.Table[0].IsAttendanceForSameDayAllowed;
            this.CompanyPermiter.IsRelievingOTDisable = response.Table[0].IsRelievingOTDisable;
            this.CompanyPermiter.IsCheckingLeaveBalanceInMusterApplicable = response.Table[0].IsCheckingLeaveBalanceInMusterApplicable;
          }
          this.isDisabled = false;
          resolve(true);
        },
        error: (err) => {
          this.isDisabled = false;
          reject(err);
        }
      });
    });
  }

  SelectDate(SelectType: string): Promise<any> {
    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.utility.SelectDate({ 'SelectType': SelectType }).subscribe({
        next: (response) => {
          if (SelectType == 'RegistrationDate') {
            this.CompanyPermiter.TodayDate = response.Table[0].RegistrationDate
          }
          this.isDisabled = false;
          resolve(true);
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    });
  }

  deleteEmp(index: number) {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to delete?';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        if (Object.keys(this.SummaryData[index]).find(key => key.startsWith('DailyAttendanceInOutId_') && this.SummaryData[index][key] && +this.SummaryData[index][key] > 0) != undefined) {
          this.musterAttendance.ESS_RemoveAttendanceOAS({
            'SelectType': 'D', SiteId: this.filter.SiteMasterID, EmpMasterId: this.SummaryData[index].EmpMasterId,
            'DesignationId': this.SummaryData[index].DesignationMasterId, 'DutyId': this.SummaryData[index].DutyMasterId,
            MonthName: this.dateFormate.fullmonth[this.filter.MonthYear.month - 1], YearName: this.filter.MonthYear.year,
          }).subscribe({
            next: (response) => {
              if (response.Error_Code == '773') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  this.updatedDatas = this.updatedDatas.filter((e: any) => e.EmpMasterId != this.SummaryData[index].EmpMasterId && e.DesignationMasterId != this.SummaryData[index].DesignationMasterId && e.DutyMasterId != this.SummaryData[index].DutyMasterId);
                  this.SummaryData.splice(index, 1);
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        } else {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = 'Attendance Removed Successfully';
          modalRef.result.then((result: any) => {
            this.updatedDatas = this.updatedDatas.filter((e: any) => e.EmpMasterId != this.SummaryData[index].EmpMasterId && e.DesignationMasterId != this.SummaryData[index].DesignationMasterId && e.DutyMasterId != this.SummaryData[index].DutyMasterId);
            this.SummaryData.splice(index, 1);
          });
          this.isDisabled = false;
        }
      }
    });
  }

  openTrackingHistory() {
    const modalRef = this.modalService.open(MusterAttendancePOCTrackingHistoryComponent, {
      size: 'xl',
      backdrop: 'static',
    });
    modalRef.componentInstance.Tracking = this.Tracking;
    modalRef.result.then(
      (result: any) => { }
    );
  }

  getDayDifference(d1: string, d2: string): number {
    const date1 = new Date(d1);
    const date2 = new Date(d2);

    // Reset hours to 0 to avoid time-related issues
    date1.setHours(0, 0, 0, 0);
    date2.setHours(0, 0, 0, 0);

    const msPerDay = 1000 * 60 * 60 * 24;
    const diff = (date2.getTime() - date1.getTime()) / msPerDay;

    return diff; // positive = date2 after date1, negative = date2 before date1
  }

  resetAll() {

    this.Dropdowns = [];
    this.Zones = [];
    this.Clients = [];
    this.Branchs = [];
    this.Sectors = [];
    this.Groups = [];
    this.Sites = [];

    this.filter.ZoneMasterID = null;
    this.filter.SectorId = null;
    this.filter.GroupId = null;
    this.filter.BranchMasterID = null;
    this.filter.ClientGroupMasterID = null;
    this.filter.SiteMasterID = null;
    this.filter.ESS_SaveAttendance_OAS = null;

    this.POCInfo.IsInternalPOCApplicable = false;
    this.POCInfo.IsClientPOCApplicable = false;
    this.POCInfo.SalaryStartDate = null;
    this.POCInfo.SalaryEndDate = null;
    this.POCInfo.IsClientPOCApplicable = false;

    this.POCInfo.InternalPOCStatus = null;
    this.POCInfo.ClientPOCStatus = null;
    this.POCInfo.IsLocked = false;
    this.POCInfo.IsReset = false;

    this.SummaryData = [];
    this.dateKeys = [];
    this.DesignationSummaryData = [];

    this.DesignationSummaryBillingData = [];
    this.Tracking = [];

    if (this.musterSummaryComponent) {
      this.musterSummaryComponent.tableData = this.SummaryData;
      this.musterSummaryComponent.updatedDatas = this.updatedDatas;
      this.musterSummaryComponent.IsLocked = this.POCInfo.IsLocked;
      this.musterSummaryComponent.CompanyPermiter = this.CompanyPermiter;
      this.musterSummaryComponent.ErrorHighlight = this.ErrorHighlight;
      this.musterSummaryComponent.OnLoad();
    }
  }

  ESS_SiteWiseAttendancePOCOASGenExcelPdf(IsMonthlySummary: Boolean, IsBillingSummary: Boolean, ispdf: Boolean) {
    this.isDisabled = true;
    this.musterAttendance.ESS_SiteWiseAttendancePOCOASGenExcelPdf({
      ispdf: ispdf, IsMonthlySummary: IsMonthlySummary, IsBillingSummary: IsBillingSummary,
      SiteId: this.filter.SiteMasterID,
      SiteCode: this.Sites.filter((e: any) => e.SiteMasterID == this.filter.SiteMasterID)[0].SiteCode,
      SiteName: this.Sites.filter((e: any) => e.SiteMasterID == this.filter.SiteMasterID)[0].SiteName,
      MonthName: this.dateFormate.fullmonth[this.filter.MonthYear.month - 1], YearName: this.filter.MonthYear.year,
      CompanyCode: this.user.CompanyCode,
      CompanyName: this.user.CompanyName,
    }).subscribe({
      next: (response) => {
        if (response) {
          if (IsMonthlySummary) {
            if (response.ftpMonthUrl != null && response.ftpMonthUrl != "") {
              window.open(response.ftpMonthUrl, '_blank');
            }
          } else if (IsBillingSummary) {
            if (response.ftpBilingUrl != null && response.ftpBilingUrl != "") {
              window.open(response.ftpBilingUrl, '_blank');
            }
          } else if (ispdf) {
            if (response.pdfUrl != null && response.pdfUrl != "") {
              window.open(response.pdfUrl, '_blank');
            }
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  clear() {
    this.SummaryData = [];
    this.updatedDatas = [];
    this.POCInfo.IsLocked = false;

    this.CompanyPermiter.IsAttendanceBeforeDaysAllowed = false;
    this.CompanyPermiter.AttendanceBeforeDays = 0;
    this.CompanyPermiter.IsAttendanceAfterDaysAllowed = false;
    this.CompanyPermiter.AttendanceAfterDays = 0;
    this.CompanyPermiter.IsUpdateDesignationDutyAllowed = false;
    this.CompanyPermiter.IsAttendanceResetAllowed = false;
    this.CompanyPermiter.IsAttendanceDeleteAllowed = false;
    this.CompanyPermiter.IsAttendanceForSameDayAllowed = false;
    this.CompanyPermiter.IsCheckingLeaveBalanceInMusterApplicable = false;
    this.CompanyPermiter.TodayDate = null;

    this.ErrorHighlight = [];

    this.musterSummaryComponent.tableData = this.SummaryData;
    this.musterSummaryComponent.updatedDatas = this.updatedDatas;
    this.musterSummaryComponent.IsLocked = this.POCInfo.IsLocked;
    this.musterSummaryComponent.CompanyPermiter = this.CompanyPermiter;
    this.musterSummaryComponent.ErrorHighlight = this.ErrorHighlight;
    this.musterSummaryComponent.OnLoad();

    this.POCInfo.SalaryStartDate = null;
    this.POCInfo.SalaryEndDate = null;

    this.DesignationSummaryData = [];
    this.DesignationSummaryBillingData = [];
    this.Tracking = [];
    this.initializeDataTable('#designationWiseSummarydata', []);
    this.initializeDataTable('#tracking', []);
    this.filter.Branch = null;
    this.filter.Client = null;
  }

  async CheckUnmatchRecodeFromDesignationSummary(): Promise<any> {
    return new Promise((resolve, reject) => {
      const arr1 = this.DesignationSummaryData.map((e: any) => ({ DesignationID: e.DesignationMasterId, DutyID: e.DutyMasterId }));
      const arr2 = this.SummaryData.filter((e: any) => e.P > 0 || e.A > 0 || e.CO > 0 || e.WO > 0 || e.H > 0 || e.CL > 0 || e.SL > 0 || e.PL > 0 || e['CALC DAYS'] > 0 || e['WORK DAYS'] > 0 || e['OT'] > 0 || e['RT'] > 0).map((e: any) => ({ DesignationID: e.DesignationMasterId, DutyID: e.DutyMasterId }));

      const unmatched = arr2.filter((a2: any) =>
        !arr1.some((a1: any) =>
          a1.DesignationID === a2.DesignationID &&
          a1.DutyID === a2.DutyID
        )
      );

      if (unmatched.length > 0) {
        resolve(false);
      } else {
        resolve(true);
      }
    });
  }

  removeFile() {
    this.ESS_AttendanceIPOCAttachment_IUUpdate('d');
  }


  uploadaknowledgment(event: any) {
    try {
      if ((event.currentTarget.accept).includes(this.common.ToLowerCase(event.target.files[0].type.split('/')[1])) ||
        (event.currentTarget.accept).includes(this.common.ToLowerCase(event.target.files[0].name.split('.')[1]))) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.UploadServices(reader.result);
          event.target.value = null;
        };
      } else {
        this.toast.show({ message: 'selected file not allow, allow file only ' + event.currentTarget.accept, type: toastTypeEnum.danger });
        event.target.value = null;
      }
    } catch (e) { }
  }

  UploadServices(Base64: any) {
    this.isDisabled = true;
    this.utility.Upload({ 'DomainName': this.user.Domain, 'folder': this.common.CompanyParameterValue.IPOCAttachment, 'CompanyCode': this.user.CompanyCode, 'FileBase64': Base64 }).subscribe((response: any) => {
      if (response.FileName != "") {
        this.POCInfo.IPOCAttachment = response.FileName;
        this.POCInfo.IPOCAttachmentURL = response.Url;

        this.ESS_AttendanceIPOCAttachment_IUUpdate('i');
      } else {
        this.toast.show({ message: 'Filte not uploaded', type: toastTypeEnum.warning });
      }
      this.isDisabled = false;
    }, (error) => {
      this.isDisabled = false;
    });
  }

  ESS_AttendanceIPOCAttachment_IUUpdate(selecttype: string) {
    this.isDisabled = true;
    this.musterAttendance.ESS_AttendanceIPOCAttachment_IUUpdate({
      'SelectType': selecttype, SiteId: this.filter.SiteMasterID,
      MonthName: this.dateFormate.fullmonth[this.filter.MonthYear.month - 1], YearName: this.filter.MonthYear.year,
      IPOCAttachment: this.POCInfo.IPOCAttachment
    }).subscribe({
      next: (response) => {
        if (selecttype == 'i') {
          if (response.Error_Code == '897') {
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
          } else {
            this.POCInfo.IPOCAttachment = null;
            this.POCInfo.IPOCAttachmentURL = null;
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
          }
        } else if (selecttype == 'd') {
          if (response.Error_Code == '898') {
            this.POCInfo.IPOCAttachment = null;
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
          } else {
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ESS_ValidateSaveAttendanceOAS(SelectType: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.musterAttendance.ESS_ValidateSaveAttendanceOAS({
        'SelectType': SelectType, SiteId: this.filter.SiteMasterID,
        AttendanceDate: null, AttendanceRemark: null,
        EmpMasterId: null, DailyAttendanceInOutId: null,
        MonthName: this.dateFormate.fullmonth[this.filter.MonthYear.month - 1], YearName: this.filter.MonthYear.year
      }).subscribe({
        next: (response) => {
          if (response.Table[0].Column1 == '01') {
            resolve(true);
          } else {
            resolve(false);
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Table1[0].Column1;
            modalRef.result.then((result: any) => {
            });
          }
        },
        complete: () => { },
        error: (error) => {
          resolve(error);
        },
      });
    });
  }
}
